function DriverSummaryCard({ driverProfile }) {
  if (!driverProfile) return null;

  return (
    <aside className="landstar-driver-card">
      <p className="landstar-kicker">Eligibility</p>
      <div className="landstar-driver-summary-row">
        <div className="landstar-driver-summary-item landstar-driver-summary-name">
          <span className="landstar-driver-summary-label">Driver</span>
          <strong>{driverProfile.driverName}</strong>
        </div>
        <div className="landstar-driver-summary-item">
          <span className="landstar-driver-summary-label">Tier</span>
          <strong>{driverProfile.rewardTier}</strong>
        </div>
        <div className="landstar-driver-summary-item">
          <span className="landstar-driver-summary-label">Year</span>
          <strong>{driverProfile.tierYear}</strong>
        </div>
        <div className="landstar-driver-summary-item">
          <span className="landstar-driver-summary-label">L-Number</span>
          <strong>{driverProfile.lNumber}</strong>
        </div>
        {driverProfile.eligibilityMonth ? (
          <div className="landstar-driver-summary-item">
            <span className="landstar-driver-summary-label">Eligibility</span>
            <strong>{driverProfile.eligibilityMonth}</strong>
          </div>
        ) : null}
      </div>
    </aside>
  );
}

export default DriverSummaryCard;
